export class AdvogadoDTO {
    id?: number;
    cpf: string;
    oab: string;
    nome: string;
    email: string;
    celular: string;


    constructor(id: number = undefined, cpf: string, oab: string, nome: string, email: string, celular: string) {
        this.id = id;
        this.cpf = cpf;
        this.oab = oab;
        this.nome = nome;
        this.email = email;
        this.celular = celular;
    }
}
